import Alpine from 'alpinejs';

Alpine.data('spacer', (desktopHeight, mobileHeight, visible) => ({
  desktopHeight,
  mobileHeight,
  visible,
  
  get styles() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    return {
      height: isMobile ? this.mobileHeight : this.desktopHeight,
      backgroundColor: this.visible ? 'rgba(255,0,0,0.3)' : 'transparent'
    };
  }
}));